'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _ProjectInfoWindow = require('../ProjectInfoWindow/ProjectInfoWindow');var _ProjectInfoWindow2 = _interopRequireDefault(_ProjectInfoWindow);
var _NoteInput = require('../Notes/NoteInput');var _NoteInput2 = _interopRequireDefault(_NoteInput);
var _ProjectCell = require('../ProjectCell/ProjectCell');var _ProjectCell2 = _interopRequireDefault(_ProjectCell);

var _note = require('../../../static/icons/note.svg');var _note2 = _interopRequireDefault(_note);
var _isDescendant = require('../../utils/isDescendant');var _isDescendant2 = _interopRequireDefault(_isDescendant);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _ProjectCellWrapper = require('./ProjectCellWrapper.scss');var _ProjectCellWrapper2 = _interopRequireDefault(_ProjectCellWrapper);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
var ProjectCellWrapper = function (_Component) {_inherits(ProjectCellWrapper, _Component);function ProjectCellWrapper() {var _temp, _this, _ret;_classCallCheck(this, ProjectCellWrapper);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showNote: false }, _this.





























    hideNote = function (evt) {
      var isNoteIcon = _this.noteWrapper && (0, _isDescendant2.default)(_this.noteWrapper, evt.target);

      if (!isNoteIcon) {
        _this.setState({ showNote: false });
      }
    }, _this.

    addNote = function (note) {return _this.props.addProjectNote(_this.props.id, note);}, _this.

    openDetails = function (evt) {
      evt.stopPropagation();
      var route = (0, _appendLocale2.default)(_this.props.locale, '/project_details/' + _this.props.id);
      var isNoteIcon = _this.noteWrapper && (0, _isDescendant2.default)(_this.noteWrapper, evt.target);
      if (isNoteIcon) return;

      if (evt.ctrlKey || evt.metaKey) {
        window.open(route);
      } else if (_this.props.isMobile) {
        _reactRouter.browserHistory.push(route);
      } else {
        _this.props.openDetailsPopup({ propertyId: _this.props.id, entityType: 'project' });
      }
    }, _this.

    toggleFavorite = function () {return _this.props.toggleFavorite(_this.props.id, '', true);}, _this.

    toggleNote = function (evt) {
      evt.stopPropagation();
      _this.setState(function (_ref) {var showNote = _ref.showNote;return { showNote: !showNote };});
    }, _this.

    renderNote = function () {return !!_this.props.projectNote &&
      _react2.default.createElement('div', {
          className: _ProjectCellWrapper2.default.noteIconWrapper,
          id: 'note_for_' + _this.props.id,
          ref: function ref(_ref2) {_this.noteWrapper = _ref2;} },

        _react2.default.createElement('img', {
          src: _note2.default,
          alt: '',
          className: _ProjectCellWrapper2.default.noteIcon,
          onClick: _this.toggleNote }),


        _this.state.showNote &&
        _react2.default.createElement('div', { className: _ProjectCellWrapper2.default.noteTooltip },
          _react2.default.createElement(_NoteInput2.default, {
            value: _this.props.projectNote,
            addNote: _this.addNote })));}, _temp), _possibleConstructorReturn(_this, _ret);}ProjectCellWrapper.prototype.componentDidMount = function componentDidMount() {document.body.addEventListener('click', this.hideNote, true);};ProjectCellWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {var projectNote = _ref3.projectNote;if (!projectNote && this.props.projectNote !== projectNote) {this.setState({ showNote: false });}};ProjectCellWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, newState) {var _this2 = this;var propChanged = function propChanged(propPath) {return (0, _get2.default)(nextProps, propPath) !== (0, _get2.default)(_this2.props, propPath);};var stateChanged = function stateChanged(path) {return (0, _get2.default)(newState, path) !== (0, _get2.default)(_this2.state, path);};return [propChanged('locale'), propChanged('childProps.location'), propChanged('isFavorite'), propChanged('projectNote'), stateChanged('showNote')].some(function (condition) {return condition === true;});};ProjectCellWrapper.prototype.componentWillUnmount = function componentWillUnmount(prevProps, prevState) {document.body.removeEventListener('click', this.hideNote, true);};ProjectCellWrapper.prototype.






  render = function render() {var _this3 = this;
    var Details = this.props.isPinInfoWindow ? _ProjectInfoWindow2.default : _ProjectCell2.default;



    return (
      _react2.default.createElement('div', { key: this.props.id, ref: function ref(_ref4) {_this3.cell = _ref4;}, className: this.props.className },
        _react2.default.createElement(Details, _extends({},
        this.props.childProps, {
          openDetails: this.openDetails,
          toggleFavorite: this.toggleFavorite,
          isFavorite: this.props.isFavorite,
          isMobile: this.props.isMobile,
          isRtl: this.props.isRtl,
          id: this.props.id,
          toggleNote: this.toggleNote,
          noteOpened: this.state.showNote,
          projectNote: this.props.projectNote,
          note: this.renderNote() }))));



  };return ProjectCellWrapper;}(_react.Component);


ProjectCellWrapper.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isPinInfoWindow: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  childProps: _propTypes2.default.object,
  openDetailsPopup: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  isFavorite: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func,
  addProjectNote: _propTypes2.default.func.isRequired,
  projectNote: _propTypes2.default.string };exports.default =


ProjectCellWrapper;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCellWrapper/ProjectCellWrapper.js
// module id = 2789
// module chunks = 0